import {Injectable} from '@angular/core';
import {TorchAPIConfiguration} from '../../../config/api.configuration';

@Injectable({
  providedIn: 'root'
})
export class TorchWorkItemsService {

  constructor(protected config: TorchAPIConfiguration) {
  }
}
